<template>
  <transition name="faq">
    <div v-if="isFaqOpen">
      <slot />
    </div>
  </transition>
</template>

<script lang="ts" setup>
import { inject, Ref } from "vue";

const isFaqOpen = inject<Ref<boolean>>("isFaqOpen");
</script>

<style lang="scss" scoped>
.faq-enter-active {
  transition: opacity 0.5s ease;
}

.faq-enter-from {
  opacity: 0;
}
</style>
